export default __webpack_public_path__ + "static/media/Padron_6000Closed.b874f218.jpg";